export default __webpack_public_path__ + "static/media/ansible.ab91e3a6.svg";